import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { Tabs, DataTab, EpmTab, PlatesTab, RfidTab, SubscriptionTab, ZonesLKTab, ZonesTab } from './client-tabs.styled';

export const ClientTabs = (props) => {
  const { tab, changeTab } = props;
  const { t } = useTranslation();

  const rights = {
    changeStatus: user.haveRight('clients.change_status'),
    update: user.haveRight('clients.update'),
    rfidList: user.haveRight('rfid.list'),
    zonesLimit: user.haveRight('clients.limits'),
    zonesLK: user.haveRight('clients.set_zones'), // set_zones
    staysList: user.haveRight('stays.list'),
    epmList: user.haveRight('csc.list'),
    plateList: user.haveRight('plates.list'),
    subscriptionList: user.haveRight('subscriptions.list'),
    rightTopup: user.haveRight('clients.replenish'),
  };

  return (
    <Tabs>
      <DataTab active={tab} onClick={() => changeTab('data')}>
        {t('form.Данные')}
      </DataTab>
      {rights.rfidList && (
        <RfidTab active={tab} onClick={() => changeTab('rfid')}>
          {t('form.RFID метки')}
        </RfidTab>
      )}
      {rights.epmList && (
        <EpmTab active={tab} onClick={() => changeTab('epm')}>
          {t('sections.БСК')}
        </EpmTab>
      )}
      {rights.plateList && (
        <PlatesTab active={tab} onClick={() => changeTab('plates')}>
          {t('sections.ГРЗ')}
        </PlatesTab>
      )}
      {rights.subscriptionList && (
        <SubscriptionTab active={tab} onClick={() => changeTab('subscription')}>
          {t('sections.Абонементы')}
        </SubscriptionTab>
      )}
      {rights.zonesLimit && (
        <ZonesTab active={tab} onClick={() => changeTab('zoneslimit')}>
          {t('sections.Лимит ТС')}
        </ZonesTab>
      )}
      {rights.zonesLK && (
        <ZonesLKTab active={tab} onClick={() => changeTab('zoneslk')}>
          {t('sections.Категории ЛК')}
        </ZonesLKTab>
      )}
    </Tabs>
  );
};
